import { Dialog, DialogContent, DialogOverlay, DialogPortal, DialogClose } from '@/components/ui/dialog';
import { ChevronDown, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Easter-egg modal that fires when Chris signs in.
 * Cheeky tabloid-style "West Ham are getting relegated" message.
 */
export function WestHamRelegationModal({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogPortal>
        <DialogOverlay className="bg-black/70" />
        <DialogContent
          className="p-0 max-w-md border-white/10 bg-transparent shadow-2xl overflow-hidden rounded-2xl [&>button]:hidden"
          data-testid="westham-easter-egg-modal"
        >
          {/* Claret header */}
          <div className="px-6 py-4 flex items-center justify-between" style={{ background: '#7A263A' }}>
            <div className="flex items-center gap-2">
              <ChevronDown className="w-4 h-4 text-white" strokeWidth={2.5} />
              <span className="text-[11px] uppercase tracking-[0.22em] text-white/95 font-bold">
                Premier League · Bulletin
              </span>
            </div>
            <DialogClose asChild>
              <button
                aria-label="Dismiss"
                className="text-white/70 hover:text-white transition-colors"
                data-testid="westham-modal-close-x"
              >
                <X className="w-4 h-4" />
              </button>
            </DialogClose>
          </div>

          {/* Body */}
          <div className="bg-[#0E1422] px-6 py-7 text-center">
            <div className="text-[11px] uppercase tracking-[0.25em] text-zinc-400 mb-2">
              Sorry, Chris...
            </div>
            <h2
              className="text-3xl font-extrabold leading-tight text-white"
              style={{ fontFamily: "'Space Grotesk', 'Inter', sans-serif" }}
            >
              West Ham are
              <br />
              <span style={{ color: '#B83A56' }}>getting relegated.</span>
            </h2>
            <p className="mt-3 text-sm text-zinc-400 italic">
              No refund on this prediction. No technology can save them.
            </p>

            <DialogClose asChild>
              <Button
                className="mt-6 w-full text-sm font-semibold tracking-wide uppercase text-white border-0"
                style={{ background: '#7A263A' }}
                onMouseEnter={(e) => { e.currentTarget.style.background = '#5C1B2B'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = '#7A263A'; }}
                data-testid="westham-modal-dismiss-btn"
              >
                Yeah, alright
              </Button>
            </DialogClose>

            <div className="mt-3 text-[10px] uppercase tracking-[0.22em] text-zinc-600">
              Brought to you by John
            </div>
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
